/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "../../";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/*!********************************************************!*\
  !*** ./src/scripts/helpers/open-helpcenter-content.js ***!
  \********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function (sdkClient, sdkConfig, contentId) {
  sdkClient, sdkConfig, contentId;
  sdkClient.getContentById(contentId, { tracking: 0 }).then(function (response) {
    window.open(sdkConfig.helpsiteURL.replace(/\/$/, '') + '/content/' + response.data.results[0].slug + '/?o=gp', '_blank');
  });
});;

/***/ }),
/* 1 */
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /home/developer/poujoulat_km_fr/src/index.js */2);


/***/ }),
/* 2 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_vendor_scss__ = __webpack_require__(/*! ./styles/_vendor.scss */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_vendor_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_vendor_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_main_js__ = __webpack_require__(/*! ./scripts/main.js */ 4);
// CSS path


// Main script path


/***/ }),
/* 3 */
/*!*********************************!*\
  !*** ./src/styles/_vendor.scss ***!
  \*********************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/*!*****************************!*\
  !*** ./src/scripts/main.js ***!
  \*****************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_import_script__ = __webpack_require__(/*! ./helpers/import-script */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_popular_init__ = __webpack_require__(/*! ./helpers/popular-init */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_search_init__ = __webpack_require__(/*! ./helpers/search-init */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_mobile_search_init__ = __webpack_require__(/*! ./helpers/mobile-search-init */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_main_search_init__ = __webpack_require__(/*! ./helpers/main-search-init */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_result_page__ = __webpack_require__(/*! ./helpers/result-page */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_result_test_page__ = __webpack_require__(/*! ./helpers/result-test-page */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_deflection_init__ = __webpack_require__(/*! ./helpers/deflection-init */ 12);
// Load helpers









// Check if conf file exists
if (typeof window.inbAppSdk === 'undefined') {
  throw new ReferenceError("Inbenta SDK couldn't be started, please contact with support for more information.");
}

// Retrieve configuration data
var app = window.inbAppSdk;
var secret = false;

// SDK configuration changes depending on the current domain.
// Defined in ./credentials.js
var domain = window.location.host || window.location.hostname;
var pathname = window.location.pathname;
if (pathname.indexOf('page-de-recherche-test') > -1) {
  domain = domain + '-test';
}
var sdkConfig = window.InbentaKMConf.domains[domain] ? window.InbentaKMConf.domains[domain] : window.InbentaKMConf.domains.default;

window.InbentaAssetsUrl = typeof sdkConfig.baseUrl !== 'undefined' ? sdkConfig.baseUrl : null;
// If SDK is executed on a non-registered domain, we don't launch it.
if (sdkConfig === undefined) {
  console.error('Domain "' + domain + ' has no authorization to run sdks.' + 'Please contact Inbenta in order to obtain credentials for this domain.');
} else {
  app.sdkAuth.inbentaKey = window.InbentaKMConf.inbentaKey;
  // Exclude test page from production statistics
  var isInternalTestPage = window.location.pathname.indexOf('article/page-de-recherche-test') > -1;
  if (isInternalTestPage) {
    app.sdkConfig.source = 'Debug';
  }

  app.sdkConfig.environment = sdkConfig.environment;

  if (typeof window.InbentaKMConf.secret != 'undefined') {
    app.sdkAuth.secret = window.InbentaKMConf.secret;
    secret = true;
  } else {
    app.sdkAuth.domainKey = sdkConfig.domainKey;
  }
}

switch (sdkConfig.id) {
  default:
    // Customize conf depending of the id
    app.sdkConfig.userType = 0;
    break;
}

// KM and search do not use the same userType
app.sdkConfig.userType = 1;

// Import & build SDK
Object(__WEBPACK_IMPORTED_MODULE_0__helpers_import_script__["a" /* default */])('https://sdk.inbenta.io/' + app.sdkProduct + '/' + app.sdkVersion + '/inbenta-' + app.sdkProduct + '-sdk.js', function () {
  Object(__WEBPACK_IMPORTED_MODULE_0__helpers_import_script__["a" /* default */])('https://sdk.inbenta.io/search/' + app.sdkVersion + '/inbenta-search-sdk.js', function () {

    // Load sdk using domains
    var sdk = InbentaKmSDK.createFromDomainKey(app.sdkAuth.domainKey, app.sdkAuth.inbentaKey, app.sdkConfig);
    var searchSdk = InbentaSearchSDK.createFromDomainKey(sdkConfig.searchDomainKey, window.InbentaKMConf.inbentaSearchKey, app.sdkConfig);

    var searchBox = void 0;
    var searchBoxMobile = void 0;
    var searchBoxMain = void 0;

    // Init test result page
    Object(__WEBPACK_IMPORTED_MODULE_6__helpers_result_test_page__["a" /* default */])(sdk, sdkConfig, searchSdk, searchBox, searchBoxMobile, searchBoxMain);

    // Init search boxes
    searchBox = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_search_init__["a" /* default */])(sdk, sdkConfig);
    searchBoxMobile = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_mobile_search_init__["a" /* default */])(sdk, sdkConfig);
    searchBoxMain = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_main_search_init__["a" /* default */])(sdk, sdkConfig);

    // Init result page
    Object(__WEBPACK_IMPORTED_MODULE_5__helpers_result_page__["a" /* default */])(sdk, sdkConfig, searchSdk, searchBox, searchBoxMobile, searchBoxMain);

    // Set-up populars
    Object(__WEBPACK_IMPORTED_MODULE_1__helpers_popular_init__["a" /* default */])(sdk, sdkConfig);

    // Set-up deflection if needed
    Object(__WEBPACK_IMPORTED_MODULE_7__helpers_deflection_init__["a" /* default */])(app, InbentaKmSDK, sdkConfig);

    document.querySelector('html').classList.remove('inbenta-km');
  });
});

/***/ }),
/* 5 */
/*!**********************************************!*\
  !*** ./src/scripts/helpers/import-script.js ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*--------------------------------------------------
|          Functions + external libraries
|---------------------------------------------------|
*/

/**
 *
 * Load script dynamically and instantly trigger a function
 *
 * @param {string} sSrc
 *   Script JS to be loaded
 *
 * @param {function} fOnload
 *   Function to be triggered when the file is completely loaded
 *
 */

/* harmony default export */ __webpack_exports__["a"] = (function (sSrc, fOnload) {
  var oScript = document.createElement("script");
  oScript.type = "text\/javascript";
  if (fOnload) {
    oScript.onload = fOnload;
  }
  document.getElementsByTagName("head")[0].appendChild(oScript, document.currentScript);
  oScript.src = sSrc;
});

/***/ }),
/* 6 */
/*!*********************************************!*\
  !*** ./src/scripts/helpers/popular-init.js ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Init popular contents
 */
/* harmony default export */ __webpack_exports__["a"] = (function (sdk, sdkConfig) {
  // Set up the top 3
  if (document.querySelector('#popular')) {
    // Set up popular module before the contact form
    var popular = sdk.component('popular', '#popular', {
      length: 3,
      contents: {
        openContentOnClick: false
      },
      labels: {
        POPULAR_TITLE: 'Questions les plus fréquentes'
      }
    });
    popular.$on('click', function (content) {
      window.open(sdkConfig.helpsiteURL.replace(/\/$/, '') + '/content/' + content.slug + '/?o=gp', '_blank');
    });
  }
});

/***/ }),
/* 7 */
/*!********************************************!*\
  !*** ./src/scripts/helpers/search-init.js ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__open_helpcenter_content__ = __webpack_require__(/*! ./open-helpcenter-content */ 0);
/**
 *
 *  Initialize  search box and autocomplete
 *
 */


/* harmony default export */ __webpack_exports__["a"] = (function (sdk, sdkConfig) {
  if (document.querySelector('#searchbox') && document.querySelector('#autocompleter')) {
    console.log('search init');
    var searchBox = sdk.component('searchBox', '#searchbox', {
      labels: {
        SEARCH_BOX_PLACEHOLDER: 'Comment faire un devis, therminox, règlementation dévoiement, sortie de toit...'
      }
    });
    var autocompleter = sdk.component('autocompleter', '#autocompleter', {});
    autocompleter.linkToSearchBox(searchBox);
    autocompleter.$on('autocompleterClick', function (contentId) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__open_helpcenter_content__["a" /* default */])(sdk.client, sdkConfig, contentId);
    });

    // When performing search, redirect to result page with query in the URL parameters
    searchBox.$on('query', function (searchQuery) {
      window.open(sdkConfig.searchResultsURL + '?query=' + searchQuery, '_self');
    });

    searchBox.untilReady.then(function () {
      var searchBars = document.querySelectorAll('.inbenta-km__search__form .inbenta-km-input');
      for (var i = 0; i < searchBars.length; i++) {
        searchBars[i].setAttribute('maxlength', '100');
      }
    });

    return searchBox;
  }
});

/***/ }),
/* 8 */
/*!***************************************************!*\
  !*** ./src/scripts/helpers/mobile-search-init.js ***!
  \***************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__open_helpcenter_content__ = __webpack_require__(/*! ./open-helpcenter-content */ 0);
/**
 *
 * Initialize the mobile version of the search bar if necessary
 *
 */



/* harmony default export */ __webpack_exports__["a"] = (function (sdk, sdkConfig) {
  if (document.querySelector('#searchbox-mobile') && document.querySelector('#autocompleter-mobile')) {
    var searchBoxMobile = sdk.component('searchBox', '#searchbox-mobile', {
      labels: {
        SEARCH_BOX_PLACEHOLDER: 'Comment faire un devis, therminox, règlementation dévoiement, sortie de toit...'
      }
    });
    var autocompleterMobile = sdk.component('autocompleter', '#autocompleter-mobile', {});
    autocompleterMobile.linkToSearchBox(searchBoxMobile);
    autocompleterMobile.$on('autocompleterClick', function (contentId) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__open_helpcenter_content__["a" /* default */])(sdk.client, sdkConfig, contentId);
    });

    // When performing search, redirect to result page with query in the URL parameters
    searchBoxMobile.$on('query', function (searchQuery) {
      window.open(sdkConfig.searchResultsURL + '?query=' + searchQuery, '_self');
    });

    searchBoxMobile.untilReady.then(function () {
      var searchBars = document.querySelectorAll('.inbenta-km__search__form .inbenta-km-input');
      for (var i = 0; i < searchBars.length; i++) {
        searchBars[i].setAttribute('maxlength', '100');
      }
    });

    return searchBoxMobile;
  }
});

/***/ }),
/* 9 */
/*!*************************************************!*\
  !*** ./src/scripts/helpers/main-search-init.js ***!
  \*************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__open_helpcenter_content__ = __webpack_require__(/*! ./open-helpcenter-content */ 0);
/**
 * Init main search box
 */



/* harmony default export */ __webpack_exports__["a"] = (function (sdk, sdkConfig) {
  if (document.querySelector('#autocompleter-main') && document.querySelector('#search-main')) {
    // Init also the main search box and autocompleter
    var searchBoxMain = sdk.component('searchBox', '#search-main', {
      labels: {
        SEARCH_BOX_PLACEHOLDER: 'Comment faire un devis, therminox, règlementation dévoiement, sortie de toit...'
      }
    });
    // When performing search, redirect to result page with query in the URL parameters
    searchBoxMain.$on('query', function (searchQuery) {
      window.open(sdkConfig.searchResultsURL + '?query=' + searchQuery, '_self');
    });
    searchBoxMain.untilReady.then(function () {
      var searchBars = document.querySelectorAll('.inbenta-km__search__form .inbenta-km-input');
      for (var i = 0; i < searchBars.length; i++) {
        searchBars[i].setAttribute('maxlength', '100');
      }
    });
    var autocompleterMain = sdk.component('autocompleter', '#autocompleter-main', {});
    autocompleterMain.linkToSearchBox(searchBoxMain);
    autocompleterMain.$on('autocompleterClick', function (contentId) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__open_helpcenter_content__["a" /* default */])(sdk.client, sdkConfig, contentId);
    });
  }
});

/***/ }),
/* 10 */
/*!********************************************!*\
  !*** ./src/scripts/helpers/result-page.js ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Manage result page initialization
 *
 * @param {KmSDK} sdk
 * @param {KmSDKConfig} sdkConfig
 * @param {SearchSDK} searchSdk
 * @param {SearchBox} searchBox
 * @param {SearchBox} searchBoxMobile
 * @param {SearchBox} searchBoxMain
 */
/* harmony default export */ __webpack_exports__["a"] = (function (sdk, sdkConfig, searchSdk, searchBox, searchBoxMobile, searchBoxMain) {

  // On the search result page
  var isPublicResultPage = window.location.href.indexOf('/recherche') > -1;

  var inbentaDiv = document.querySelector('#inbenta');
  if (isPublicResultPage && inbentaDiv) {
    // Add loader div
    var div = document.createElement('div');
    div.innerHTML = '<div id="loader"></div>';

    // Find the inbenta div
    inbentaDiv.appendChild(div);

    // Init 'KM' result div
    var results = sdk.component('results', '#results', {
      labels: {
        RESULTS_TEXT: '\n          <img class="contents__title__picto" src="https://static-or00.inbenta.com/c26951666536b7d136620a7118c39be362b03f40edaa90c526ed66c55a1304eb/Design/PictoFaq.png">\n          Dans notre centre d\'aide\n        ',
        RESULTS_NOT_FOUND_TEXT: 'Nous n\'avons trouvé aucun résultat pour votre recherche ',
        RESULTS_NOT_FOUND_TITLE: 'Désolé'
      },
      contents: {
        openContentOnClick: false,
        ratings: {
          labels: {
            RATINGS_INTRODUCTION: 'Avons-nous répondu à votre question ?',
            RATINGS_COMMENT_INTRODUCTION: 'Nous sommes d\xE9sol\xE9s de ne pas avoir r\xE9pondu \xE0 votre question :-(\n              <br> Vous pouvez nous aider \xE0 am\xE9liorer notre r\xE9ponse en nous laissant un commentaire :',
            RATINGS_SUBMIT_COMMENT_BUTTON: 'Envoyer',
            RATINGS_GRETTINGS_TEXT: 'Merci ! Nous sommes ravis d\u2019avoir pu vous aider.\xA0<br>\n            N\u2019h\xE9sitez pas \xE0 poser une nouvelle question ou \xE0 visiter notre site poujoulat.fr'
          },
          elements: [{
            id: 1,
            label: 'Oui',
            comment: false
          }, {
            id: 2,
            label: 'Non',
            comment: true
          }]
        }
      }
    });
    // Set up result click action
    results.$on('click', function (content) {
      return window.open(sdkConfig.helpsiteURL.replace(/\/$/, '') + '/content/' + content.slug + '/?o=gp', '_blank');
    });

    // Init the two 'search' result divs
    var searchResultsProduct = searchSdk.component('results', '#resultsProduct', {
      resultsPerPage: 3,
      transformData: function transformData(result) {
        result.title = result.title.replace('&#039;', '\'');
        result.attributes.BEST_DYNABS = result.attributes.DESCRIPTION;
        return result;
      },
      templates: {
        header: '\n        <div class="inbenta-km-subtitle contents__title">\n          <div class="contents__title__text">\n          <img class="contents__title__picto" src="https://static-or00.inbenta.com/c26951666536b7d136620a7118c39be362b03f40edaa90c526ed66c55a1304eb/Design/PictoProduits.png">\n            Dans nos produits et nos solutions\n          </div>\n        </div>'
      },
      forceFilters: ["TYPE:Produit"]
    });
    var searchResultsMag = searchSdk.component('results', '#resultsMag', {
      resultsPerPage: 3,
      transformData: function transformData(result) {
        result.title = result.title.replace('&#039;', '\'');
        result.attributes.BEST_DYNABS = result.attributes.DESCRIPTION;
        return result;
      },
      templates: {
        header: '\n          <div class="inbenta-km-subtitle contents__title">\n            <div class="contents__title__text">\n              <img class="contents__title__picto" src="https://static-or00.inbenta.com/c26951666536b7d136620a7118c39be362b03f40edaa90c526ed66c55a1304eb/Design/PictoChat.png">\n              Dans tous nos articles\n            </div>\n        </div>'
      },
      forceFilters: ["TYPE:Mag"]
    });

    // Setup external clicks on search results
    searchResultsMag.on('click', function (content) {
      var KMSearchCode = results.getSearchCode();
      sdk.client.track('external_click', {
        externalCode: content.tracking.externalCode,
        searchCode: KMSearchCode
      });
    });
    searchResultsProduct.on('click', function (content) {
      var KMSearchCode = results.getSearchCode();
      sdk.client.track('external_click', {
        externalCode: content.tracking.externalCode,
        searchCode: KMSearchCode
      });
    });

    // Link KM result div to desktop menu search boxes
    if (searchBox) {
      results.linkToSearchBox(searchBox);
      // Link search result divs to floating search box
      searchBox.$on('query', function (newQuery) {
        searchResultsMag.searchStore.query = newQuery;
        searchResultsProduct.searchStore.query = newQuery;
      });
    }
    // Link KM result div to mobile menu search box
    if (searchBoxMobile) {
      results.linkToSearchBox(searchBoxMobile);
      // Link search result divs to floating search box
      searchBoxMobile.$on('query', function (newQuery) {
        searchResultsMag.searchStore.query = newQuery;
        searchResultsProduct.searchStore.query = newQuery;
      });
    }
    // Link KM result div to body search box
    if (searchBoxMain) {
      results.linkToSearchBox(searchBoxMain);
      // Link search result divs to main search box
      searchBoxMain.$on('query', function (newQuery) {
        searchResultsMag.searchStore.query = newQuery;
        searchResultsProduct.searchStore.query = newQuery;
      });
    }

    // Check URL for query string or contentID
    var queryString = new URLSearchParams(window.location.search);
    var query = queryString.get('query') || '';
    if (query !== '') {
      // Display loader
      var loader = searchSdk.component('loader', '#loader');
      searchResultsMag.linkTo(loader);
      var searchMagHasRes = false;
      var searchPrdHasRes = false;
      results.setQuery(query);
      searchResultsMag.searchStore.query = query;
      searchResultsProduct.searchStore.query = query;
      searchResultsMag.searchStore.on('result', function () {
        searchMagHasRes = searchResultsProduct.searchStore.hasResults;
      });
      searchResultsProduct.searchStore.on('result', function () {
        if (!searchResultsMag.searchStore.hasResults && !searchResultsProduct.searchStore.hasResults) {
          var noResultDiv = document.querySelector('body #inbenta .inbenta-km__results__not-found');
          var additionalText = '<div>Veuillez poser une autre question ou laissez-vous guider dans notre\n            <a href="https://aide.poujoulat.fr/">centre d\'aide</a>.</div>';
          noResultDiv.insertAdjacentHTML('beforeend', additionalText);
          noResultDiv.style.display = 'block';
        }
      });
    }

    results.$on('changed', function (searchData) {
      console.log(searchData);
      setTimeout(function () {
        if (query.match(/\d{2}[-.\/ ]\d{3}[-.\/ ]\d{2}|\d{3}[-.\/ ]\d{2}/) !== null || query.match(/\d{4}\d*.?\d{1}\d*|\d{2}.\d{3}.\d{3}/) !== null) {
          var firstPhrase = document.createElement('div');
          firstPhrase.className = 'inbenta-km__results__contents__title';
          firstPhrase.innerHTML = 'Il semble que vous recherchez un produit précis, ces questions peuvent peut-être vous aider :';
          var secondPhrase = document.createElement('div');
          secondPhrase.className = 'inbenta-km__results__contents__subtitle';
          var node = null;
          if (searchData.results.length > 0) {
            node = document.querySelector('.inbenta-km__results .inbenta-km__results__extended');
          } else {
            node = document.querySelector('.inbenta-km__results .inbenta-km__results__not-found');
            document.querySelector('.inbenta-km__results__not-found').style.display = 'block';
          }

          var parentNode = node.parentNode;
          parentNode.insertBefore(firstPhrase, node);

          document.querySelector('.inbenta-km__results').appendChild(secondPhrase);

          var phrase = 'Notez que certaines informations ne sont accessibles qu\'aux professionnels dotés d\'un {{ link_1 }}<br/>Vous êtes un professionnel mais vous n\'avez pas de compte pro ? {{ link_2 }}.';

          sdk.client.getCrossSellingById(3).then(function (response) {
            var attributes = response.data.results[0].attributes;
            var tracking = response.data.results[0].tracking;

            phrase = phrase.replace('{{ link_1 }}', '<a data-click="' + tracking.clickCode + '" target="_blank" href="' + attributes.URL + '">' + attributes.TEXT + '</a>');

            sdk.client.getCrossSellingById(4).then(function (response) {
              var attributes = response.data.results[0].attributes;
              var tracking = response.data.results[0].tracking;

              phrase = phrase.replace('{{ link_2 }}', '<a data-click="' + tracking.clickCode + '" target="_blank" href="' + attributes.URL + '">' + attributes.TEXT + '</a>');

              secondPhrase.innerHTML = phrase;

              // Results when id product
              var crosssellingsProduct = document.querySelectorAll('.inbenta-km__results__contents__subtitle a');
              if (crosssellingsProduct.length > 0) {
                for (var i = 0; i < crosssellingsProduct.length; i++) {
                  crosssellingsProduct[i].addEventListener("click", function (element) {
                    var clickCode = element.currentTarget.getAttribute('data-click');
                    sdk.client.track('click', {
                      code: clickCode
                    });
                  });
                }
              }
            });
          });
        }
      }, 500);
    });

    // Detect the case where no result returned from KM instance but search instance returned results
    var resultsDivs = document.querySelectorAll('.inbenta-search-results');
    var observer = new MutationObserver(function (mutations) {
      var disp = 0;
      var resultsDivs = document.querySelectorAll('.inbenta-search-results');
      resultsDivs.forEach(function (element) {
        if (element.style.display !== 'none') {
          disp += 1;
        };
      });
      var noResultDiv = document.querySelector('body #inbenta .inbenta-km__results__not-found');
      if (disp === 0) {
        noResultDiv.style.display = 'block';
      }
    });
    resultsDivs.forEach(function (div) {
      observer.observe(div, { attributes: true, attributeFilter: ['style'] });
    });
  }
});

/***/ }),
/* 11 */
/*!*************************************************!*\
  !*** ./src/scripts/helpers/result-test-page.js ***!
  \*************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Manage result page initialization
 */
/* harmony default export */ __webpack_exports__["a"] = (function (sdk, sdkConfig, searchSdk, searchBox, searchBoxMobile, searchBoxMain) {

  // On the search result page
  var isTestResultPage = window.location.href.indexOf('/page-de-recherche-test') > -1;

  if (isTestResultPage) {

    var inbentaDiv = document.querySelector('#inbenta');
    if (!inbentaDiv) {
      // Inject inbenta template
      var inbentaContainer = document.querySelector('.detail-energie-body .inbenta-search.inbenta-search--header');
      var template = '<div id="search-main"></div>\n        <div id="autocompleter-main"></div>\n        <div id="results"></div>\n        <div id="resultsProduct"></div>\n        <div id="resultsMag"></div>';
      var divToInject = document.createElement('div');
      divToInject.id = 'inbenta';
      divToInject.innerHTML = template;
      inbentaContainer.insertAdjacentElement('afterend', divToInject);
      inbentaContainer.remove();
      inbentaDiv = document.querySelector('#inbenta');
    }

    // Add loader div
    var div = document.createElement('div');
    div.innerHTML = '<div id="loader"></div>';

    // Find the inbenta div
    inbentaDiv.appendChild(div);

    // Init 'KM' result div
    var results = sdk.component('results', '#results', {
      labels: {
        RESULTS_TEXT: '\n          <img class="contents__title__picto" src="https://static-or00.inbenta.com/c26951666536b7d136620a7118c39be362b03f40edaa90c526ed66c55a1304eb/Design/PictoFaq.png">\n          Dans notre centre d\'aide\n        ',
        RESULTS_NOT_FOUND_TEXT: 'Nous n\'avons trouvé aucun résultat pour votre recherche ',
        RESULTS_NOT_FOUND_TITLE: 'Désolé'
      },
      contents: {
        openContentOnClick: false,
        ratings: {
          labels: {
            RATINGS_INTRODUCTION: 'Avons-nous répondu à votre question ?',
            RATINGS_COMMENT_INTRODUCTION: 'Nous sommes d\xE9sol\xE9s de ne pas avoir r\xE9pondu \xE0 votre question :-(\n              <br> Vous pouvez nous aider \xE0 am\xE9liorer notre r\xE9ponse en nous laissant un commentaire :',
            RATINGS_SUBMIT_COMMENT_BUTTON: 'Envoyer',
            RATINGS_GRETTINGS_TEXT: 'Merci ! Nous sommes ravis d\u2019avoir pu vous aider.\xA0<br>\n            N\u2019h\xE9sitez pas \xE0 poser une nouvelle question ou \xE0 visiter notre site poujoulat.fr'
          },
          elements: [{
            id: 1,
            label: 'Oui',
            comment: false
          }, {
            id: 2,
            label: 'Non',
            comment: true
          }]
        }
      }
    });
    // Set up result click action
    results.$on('click', function (content) {
      return window.open(sdkConfig.helpsiteURL.replace(/\/$/, '') + '/content/' + content.slug + '/?o=gp', '_blank');
    });
    // Init the two 'search' result divs
    var searchResultsProduct = searchSdk.component('results', '#resultsProduct', {
      resultsPerPage: 3,
      transformData: function transformData(result) {
        result.title = result.title.replace('&#039;', '\'');
        result.attributes.BEST_DYNABS = result.attributes.DESCRIPTION;
        return result;
      },
      templates: {
        header: '\n        <div class="inbenta-km-subtitle contents__title">\n          <div class="contents__title__text">\n          <img class="contents__title__picto" src="https://static-or00.inbenta.com/c26951666536b7d136620a7118c39be362b03f40edaa90c526ed66c55a1304eb/Design/PictoProduits.png">\n            Dans nos produits et nos solutions\n          </div>\n        </div>'
      },
      forceFilters: ["TYPE:Produit"]
    });
    var searchResultsMag = searchSdk.component('results', '#resultsMag', {
      resultsPerPage: 3,
      transformData: function transformData(result) {
        result.title = result.title.replace('&#039;', '\'');
        result.attributes.BEST_DYNABS = result.attributes.DESCRIPTION;
        return result;
      },
      templates: {
        header: '\n          <div class="inbenta-km-subtitle contents__title">\n            <div class="contents__title__text">\n              <img class="contents__title__picto" src="https://static-or00.inbenta.com/c26951666536b7d136620a7118c39be362b03f40edaa90c526ed66c55a1304eb/Design/PictoChat.png">\n              Dans tous nos articles\n            </div>\n        </div>'
      },
      forceFilters: ["TYPE:Mag"]
    });

    // Setup external clicks on search results
    searchResultsMag.on('click', function (content) {
      var KMSearchCode = results.getSearchCode();
      sdk.client.track('external_click', {
        externalCode: content.tracking.externalCode,
        searchCode: KMSearchCode
      });
    });
    searchResultsProduct.on('click', function (content) {
      var KMSearchCode = results.getSearchCode();
      sdk.client.track('external_click', {
        externalCode: content.tracking.externalCode,
        searchCode: KMSearchCode
      });
    });

    // Link KM result div to desktop menu search boxes
    if (searchBox) {
      results.linkToSearchBox(searchBox);
      // Link search result divs to floating search box
      searchBox.$on('query', function (newQuery) {
        searchResultsMag.searchStore.query = newQuery;
        searchResultsProduct.searchStore.query = newQuery;
      });
    }
    // Link KM result div to mobile menu search box
    if (searchBoxMobile) {
      results.linkToSearchBox(searchBoxMobile);
      // Link search result divs to floating search box
      searchBoxMobile.$on('query', function (newQuery) {
        searchResultsMag.searchStore.query = newQuery;
        searchResultsProduct.searchStore.query = newQuery;
      });
    }
    // Link KM result div to body search box
    if (searchBoxMain) {
      results.linkToSearchBox(searchBoxMain);
      // Link search result divs to main search box
      searchBoxMain.$on('query', function (newQuery) {
        searchResultsMag.searchStore.query = newQuery;
        searchResultsProduct.searchStore.query = newQuery;
      });
    }

    // Check URL for query string or contentID
    var queryString = new URLSearchParams(window.location.search);
    var query = queryString.get('query') || '';
    if (query !== '') {
      // Display loader
      var loader = searchSdk.component('loader', '#loader');
      searchResultsMag.linkTo(loader);
      var searchMagHasRes = false;
      var searchPrdHasRes = false;
      results.setQuery(query);
      searchResultsMag.searchStore.query = query;
      searchResultsProduct.searchStore.query = query;
      searchResultsMag.searchStore.on('result', function () {
        searchMagHasRes = searchResultsProduct.searchStore.hasResults;
      });
      searchResultsProduct.searchStore.on('result', function () {
        if (!searchResultsMag.searchStore.hasResults && !searchResultsProduct.searchStore.hasResults) {
          var noResultDiv = document.querySelector('body #inbenta .inbenta-km__results__not-found');
          var additionalText = '<div>Veuillez poser une autre question ou laissez-vous guider dans notre\n            <a href="https://aide.poujoulat.fr/">centre d\'aide</a>.</div>';
          noResultDiv.insertAdjacentHTML('beforeend', additionalText);
          noResultDiv.style.display = 'block';
        }
      });
    }

    // Detect the case where no result returned from KM instance but search instance returned results
    var resultsDivs = document.querySelectorAll('.inbenta-search-results');
    var observer = new MutationObserver(function (mutations) {
      var disp = 0;
      var resultsDivs = document.querySelectorAll('.inbenta-search-results');
      resultsDivs.forEach(function (element) {
        if (element.style.display !== 'none') {
          disp += 1;
        };
      });
      var noResultDiv = document.querySelector('body #inbenta .inbenta-km__results__not-found');
      if (disp === 0) {
        noResultDiv.style.display = 'block';
      }
    });
    resultsDivs.forEach(function (div) {
      observer.observe(div, { attributes: true, attributeFilter: ['style'] });
    });
  }
});

/***/ }),
/* 12 */
/*!************************************************!*\
  !*** ./src/scripts/helpers/deflection-init.js ***!
  \************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Set-up deflection tool with adapted configuration if contact form is
 * detected on the page
 *
 * @param {object} app
 * @param {InbentaKmSDK} InbentaKmSDK
 * @param {KmSDKConfig} sdkConfig
 */
/* harmony default export */ __webpack_exports__["a"] = (function (app, InbentaKmSDK, sdkConfig) {
  // Set up deflection on contact form
  var commentBox = document.querySelector('#commentaire');
  if (commentBox) {
    // Same conf as KM but with different userType
    var deflectionConf = sdkConfig;
    deflectionConf.userType = 2;
    deflectionConf.source = 'deflection';

    // Create SDK object
    var deflectionSdk = InbentaKmSDK.createFromDomainKey(app.sdkAuth.domainKey, app.sdkAuth.inbentaKey, deflectionConf);
    var deflection = deflectionSdk.component('deflection', '#deflection', {
      labels: {
        INSTANTS_TITLE: 'Ces réponses peuvent vous intéresser'
      },
      contents: {
        openContentOnClick: false
      },
      debounceTime: 250,
      triggers: ['.', ',', ':', ';', '(', ')', '¿', '?', '¡', '!', ' ']
    });
    deflection.linkToInput(commentBox);
    deflection.$on('click', function (content) {
      // Handle tracking
      var query = commentBox.value;
      deflectionSdk.client.search(query, {
        length: 3
      }).then(function (response) {
        response.data.results.forEach(function (element) {
          if (element.id === content.id) {
            deflectionSdk.client.track('click', { code: element.tracking.clickCode });
            window.activeRateCode = element.tracking.rateCode;
          }
        });
        window.searchCode = response.data.tracking.searchCode;
        window.open(sdkConfig.helpsiteURL.replace(/\/$/, '') + '/content/' + content.slug + '/?o=gp', '_blank');
      });
    });

    // The test page has no form submit button
    var submitButton = document.querySelector('#submit-contact-btn');
    if (submitButton) {
      document.querySelector('#submit-contact-btn').parentElement.addEventListener('submit', function () {
        var userQuery = commentBox.value;
        deflectionSdk.client.track('contact_ticket', {
          value: userQuery
        });
        deflectionSdk.client.track('search_rate', {
          code: window.searchCode,
          value: 4,
          comment: userQuery
        });
      }, {
        // Before sending
        capture: true,
        // Only once
        once: true
      });
    }
  }
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// assets/js/inbenta-core.min.js